import { assetUrl } from "@/lib/assets";
"use client";

import React from "react";
const statsData = [{
  id: 1,
  pillValue: "+500",
  label: "IGLESIAS EN COSTA RICA.",
  pillFirst: true
}, {
  id: 2,
  pillValue: "MINISTROS",
  label: "38,387",
  pillFirst: false
}, {
  id: 3,
  pillValue: "5,713",
  label: "Misioneros",
  pillFirst: true
}, {
  id: 4,
  pillValue: "ADHERENTES EN CR.",
  label: "+500,000",
  pillFirst: false
}, {
  id: 5,
  pillValue: "451,512",
  label: "Iglesias en el mundo",
  pillFirst: false
}, {
  id: 6,
  pillValue: "ADHERENTES EN TODO EL MUNDO",
  label: "88,866,189",
  pillFirst: false
}];
export default function Statistics() {
  return <section id="churchstatistics" data-nav="light" className="acad-about-statistics bg-background py-10 md:py-16 text-foreground font-sans">
      <div className="page-container">
        <div className="acad-about-statistics-card acad-reveal relative overflow-hidden rounded-3xl bg-destructive px-6 py-10 sm:px-10 sm:py-14 md:px-14 md:py-16 text-white shadow-xl">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-8">
            {/* Left Column: Stats list */}
            <div className="flex flex-col justify-center space-y-4 sm:space-y-5 lg:col-span-7">
              <div className="sr-only">
                <h2>Estadísticas de las Asambleas de Dios</h2>
              </div>

              {statsData.map((stat, index) => <div key={stat.id} data-index={index} className="flex flex-wrap items-center gap-2.5 sm:gap-3.5 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
                  {stat.pillFirst ? <>
                      <span className="inline-flex items-center rounded-full bg-white px-4 py-1 sm:px-5 sm:py-1.5 text-destructive font-extrabold shadow-sm">
                        {stat.pillValue}
                      </span>
                      <span className="text-white uppercase tracking-normal font-bold">
                        {stat.label}
                      </span>
                    </> : <>
                      <span className="text-white font-extrabold">
                        {stat.label}
                      </span>
                      <span className="inline-flex items-center rounded-full bg-white px-4 py-1 sm:px-5 sm:py-1.5 text-destructive font-bold uppercase shadow-sm">
                        {stat.pillValue}
                      </span>
                    </>}
                </div>)}
            </div>

            {/* Right Column: Purple-lit congregation image */}
            <div className="relative lg:col-span-5">
              <div className="group relative overflow-hidden rounded-2xl border border-white/10 bg-black/20 shadow-2xl">
                <img alt="Congregación reunida en adoración con luces púrpuras" loading="lazy" decoding="async" className="h-72 w-full object-cover sm:h-84 md:h-96 lg:h-108 transition-transform duration-500 group-hover:scale-105" src={assetUrl("WhatsApp-Image-2026-08-21-at-9.10.13-AM.jpeg")} />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
